import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import CLocalizedTextStringStatic from '../../../components/CLocalizedTextStringStatic';
import CSortDropdown from '../../../components/CSortDropdown';
import { operationsSections } from '../../../constants/operationsSections';
import { type EPortfolioManagementTabs } from '../../../enums/EPortfolioManagementTabs';
import { PageRoutes } from '../../../enums/enums';

interface Props {
  factsheetId: string;
  tabs: EPortfolioManagementTabs[];
  currentTab: EPortfolioManagementTabs;
  children?: React.ReactNode;
}

export default function PortfolioManagementsStickyHeader(props: Props) {
  const navigate = useNavigate();
  const location = useLocation();

  const sortDropdownOptions = props.tabs.reduce<Record<string, string>>((acc, tab) => {
    acc[tab] = CLocalizedTextStringStatic(operationsSections[tab].dictKey);
    return acc;
  }, {});

  const handleNavigate = (selectedKey: string) => {
    const selectedTab = selectedKey as EPortfolioManagementTabs;

    navigate({
      pathname: `/${PageRoutes.OPS_NEWS_OUTLET}/${props.factsheetId}/${operationsSections[selectedTab].path}`,
      search: location.search
    });
  };

  return (
    <div className={'flex flex-row items-center flex-nowrap gap-6'}>
      <div className={'grow min-w-0'}>{props.children}</div>
      <div className={'flex justify-end'}>
        <CSortDropdown
          labelDesc={CLocalizedTextStringStatic('globalNavLabel')}
          options={sortDropdownOptions}
          defaultKey={props.currentTab}
          onChange={handleNavigate}
        />
      </div>
    </div>
  );
}
